<h1 mat-dialog-title id="addEquipmentTitle" class="text-center">{{dialogTitle}}</h1>
<form class="example-form" id="form" [formGroup]="maintenanceForm">
    <div class="row">
        <div class="col-6">
            <label class="block uppercase text-gray-600 text-xs font-bold mb-3" >{{'MANAGEMENT_MAINTENANACE.MAINTENANACE_EQUIPMENT' | translate}}</label>
            <mat-form-field>
                <mat-select formControlName="equipment" [(value)]="selectedTitle" (selectionChange)="onSelectTitle()">
                    <mat-option *ngFor="let equipment of equipmentList" [value]="equipment.title">
                        {{ equipment.title }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-6">
            <div *ngIf="titleOptions && titleOptions.length > 0 else noOption">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" >{{'MANAGEMENT_MAINTENANACE.MAINTENANACE_TYPE_CHOOSE' | translate}}</label>

                <mat-form-field>
                    <mat-select formControlName="equipment_type" [(value)]="selectedEquipmentType">
                        <mat-option *ngFor="let type of titleOptions" [value]="type">
                            {{ type }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <ng-template #noOption>
                <div>
                    <label class="block uppercase text-gray-600 text-xs font-bold mb-3">{{'MANAGEMENT_MAINTENANACE.MAINTENANACE_TYPE' | translate}}</label>

                    <mat-form-field>
                        <input matInput formControlName="equipment_type"/>
                    </mat-form-field>
                </div>
            </ng-template>
        </div>
    </div>
    <div class="row">
        <div class="col-5">
            <label class="block uppercase text-gray-600 text-xs font-bold mb-3">{{'MANAGEMENT_MAINTENANACE.MAINTENANACE' | translate}}</label>

            <mat-form-field>
                <mat-select formControlName="maintenance_type">
                    <mat-option *ngFor="let equipment of maintenanceType" value="{{equipment}}">
                        {{equipment}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-5 ml-10">
            <label class="block uppercase text-gray-600 text-xs font-bold mb-3" >{{'MANAGEMENT_MAINTENANACE.RESPONSIBLE_PERSON' | translate}}</label>

            <mat-form-field>
                <input matInput formControlName="responsible_person" />
            </mat-form-field>
        </div>
    </div>
    <div class="col-12">
        <label class="block uppercase text-gray-600 text-xs font-bold mb-3">{{'MANAGEMENT_MAINTENANACE.DATE' | translate}}</label>

        <mat-form-field>
            <input matInput formControlName="maintenance_datetime" [matDatepicker]="picker">
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
    </div>
    <div class="col-12">
        <label class="block uppercase text-gray-600 text-xs font-bold mb-3">{{'MANAGEMENT_MAINTENANACE.COMMENT' | translate}}</label>

        <mat-form-field class="example-full-width">
            <textarea matInput formControlName="paratirisis"></textarea>
        </mat-form-field>
    </div>
</form>
<div id="buttons_group" class="mt-2 p-3 float-right">
    <div class="row">
        <div class="col-5">
            <button mat-raised-button mat-dialog-close="Close"
                style="background-color: red; color: white;">Close</button>
        </div>
        <div class="col-5">
            <button mat-raised-button mat-dialog-close style="background-color: #3fb56d; color: white;"
                (click)="addMaintenanceLogs()">{{actionButton}}</button>
        </div>
    </div>
</div>